import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import { EERIE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { useTracker } from '../tracking/useTracker';
const StyledSpan = styled.span.withConfig({
  displayName: "MobileLearnMore__StyledSpan",
  componentId: "sc-131ua2p-0"
})(["font-size:1rem;"]);
const LearnMoreLink = styled(UIHelpLink).withConfig({
  displayName: "MobileLearnMore__LearnMoreLink",
  componentId: "sc-131ua2p-1"
})(["margin-left:5px;"]);
const StyledHTMLMessage = styled(FormattedHTMLMessage).withConfig({
  displayName: "MobileLearnMore__StyledHTMLMessage",
  componentId: "sc-131ua2p-2"
})(["font-size:1rem;"]);
export const MobileLearnMore = ({
  stepKey,
  tooltipText
}) => {
  const {
    isMobile
  } = useResponsiveness();
  const Tracker = useTracker();

  const trackOpen = () => {
    Tracker.signupInteraction('open-tooltip');
  };

  if (!isMobile) {
    return null;
  }

  return /*#__PURE__*/_jsxs(StyledSpan, {
    children: [/*#__PURE__*/_jsx(UIIcon, {
      color: EERIE,
      name: "info"
    }), /*#__PURE__*/_jsx(LearnMoreLink, {
      content: {
        header: /*#__PURE__*/_jsx("div", {}),
        body: tooltipText
      },
      showCloseButton: true,
      onOpenChange: trackOpen,
      children: /*#__PURE__*/_jsx(StyledHTMLMessage, {
        message: `views.${stepKey}.learnMore`
      })
    })]
  });
};
export default MobileLearnMore;